import { Box, Button } from "@mui/material";
import Breadcrumbs from "components/common/Breadcrumbs";
import ClientForm from "./ClientForm";
import useClients from "hooks/useClients";
import { ArrowBack, Sync, SyncDisabled } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import ClientDeactivateModal from "./ClientDeactivateModal";
import ClientReactivateModal from "./ClientReactivateModal";
import ClientDeactivateAssetRetrievalModal from "./ClientDeactivateAssetRetrievalModal";

export function ClientEdit() {
  const {
    client,
    updateStatus,
    deactivateOpen,
    setDeactivateOpen,
    reactivateOpen,
    setReactivateOpen,
    deactivateAssetRetrievalOpen,
    setDeactivateAssetRetrievalOpen,
    updateAssetRetrievalStatus,
  } = useClients();
  const navigate = useNavigate();

  return (
    <Box>
      <Breadcrumbs
        data={[
          { label: "Logistics", to: "/logistics?logistics_status=scheduled" },
          { label: "Clients", to: "/logistics/clients" },
          { label: client?.name, to: `/logistics/clients/${client?.uuid}` },
          { label: "Edit", to: `/logistics/clients/${client?.uuid}/edit` },
        ]}
      ></Breadcrumbs>
      <Box display="flex" justifyContent="space-between" mt={4}>
        <Button size="small" variant="text" startIcon={<ArrowBack />} onClick={() => navigate(-1)}>
          back to clients
        </Button>
        {client && (
          <Box display="flex" gap={1}>
            {client.state == "inactive" ? (
              <Button
                variant="contained"
                size="small"
                onClick={() => setReactivateOpen(true)}
                startIcon={<Sync />}
                color="success"
              >
                Reactivate client
              </Button>
            ) : (
              <Button
                variant="contained"
                size="small"
                onClick={() => setDeactivateOpen(true)}
                startIcon={<SyncDisabled />}
                color="error"
              >
                Deactivate client
              </Button>
            )}
            <Button
              variant="contained"
              size="small"
              onClick={() => setDeactivateAssetRetrievalOpen(true)}
              startIcon={<SyncDisabled />}
              color="error"
              disabled={client.state == "inactive"}
            >
              {client && client.assetRetrievalSuspended == true
                ? `Activate Asset Retrieval`
                : "Deactivate Asset Retrieval"}
            </Button>
          </Box>
        )}
      </Box>

      {client?.assetRetrievalSuspended ? "true" : "false"}
      <Box mt={2}>
        <ClientForm client={client} />
      </Box>
      <ClientDeactivateModal open={deactivateOpen} setOpen={setDeactivateOpen} updateStatus={updateStatus} />
      <ClientReactivateModal open={reactivateOpen} setOpen={setReactivateOpen} updateStatus={updateStatus} />
      {client && (
        <ClientDeactivateAssetRetrievalModal
          open={deactivateAssetRetrievalOpen}
          enabled={client?.assetRetrievalSuspended}
          reason={client?.assetRetrievalSuspendedReason || ""}
          setOpen={setDeactivateAssetRetrievalOpen}
          updateStatus={updateAssetRetrievalStatus}
        />
      )}
    </Box>
  );
}
